import axios from '../providers/axios';
import apiFiles from '../providers/apiFiles';

export const QUERY_BY_BOARD = 'plate';
export const QUERY_BY_ID = 'id';

export const patchVehicle = (
  data,
  id = null,
  file,
  consentFormFile,
  freightId = null,
  uploadedCertificates = []
) => {
  const newData = new FormData();

  if(file){
    newData.append('crlvFile', file);
    newData.append('hasCrlvFile', true);
  }

  if(freightId){
    newData.append('freightId', freightId);
  }
   
  if(consentFormFile){
    newData.append('consentFormFile', consentFormFile);
  }
   
  Object.entries(data)
    // eslint-disable-next-line no-unused-vars
    .filter(([_key, value]) => value !== undefined && value !== null)
    .map(([key, value]) => {
      if (Array.isArray(value)) {
        newData.append(key, JSON.stringify(value));
      } else {
        newData.append(key, value);
      }
    });

  if (uploadedCertificates.length > 0) {
    newData.append('certificates', JSON.stringify(uploadedCertificates));
  }

  return id === null
    ? axios.post('/vehicles', newData)
    : axios.patch(`/vehicles/${id}`, newData);
};

export const getTypes = () => axios('/types/vehicles');
export const getBodies = () => axios('/types/bodyworks');
export const getManufacturers = q => axios('/types/brands', { params: { q } });
export const getModels = (manuf, q) => axios(`/types/models/${manuf}`, { params: { q } });
export const findById = id => axios.get(`/vehicles/${id}`);
export const findByPlate = plate => axios.get(`/vehicles/plate/${plate}`);
export const findByRenavam = renavam => axios.get(`/vehicles/renavam/${renavam}`);
export const findByChassis = chassis => axios.get(`/vehicles/chassis/${chassis}`);
export const queryVehicles = q => axios.get('/vehicles', { params: { q } });
export const queryCabs = q => axios.get('/vehicles/available/cabs', { params: { q } });
export const validateVehicle = vehicle => axios.get(`/vehicles/${vehicle.id}/complete`);
export const requiredFreight = data => axios.get('/freight/required', data);
export const getVehicleCertificates = () => axios.get('/query/custom/certificate-types/vehicle');
export const saveCertificate = data => apiFiles.post('/doc', data);
export const getCompanyConfiguration = () => axios.get('/query/custom/company-configuration');
export const getCompartmentTypes = () => axios.get('/query/custom/compartment-type');

export const fetchQueryFreight = (page, query) => 
  axios.get(`freight?limit=10&page=${page}&q=${query}`);

const queryTowsByPosition = position => q => axios
  .get(`/vehicles/available/tows/${position}`, { params: { q } });

export const queryTows = q => axios.get('/vehicles/available/tows', { params: { q } });
export const queryFirstTows = queryTowsByPosition(1);
export const querySecondTows = queryTowsByPosition(2);
export const queryThirdTows = queryTowsByPosition(3);

export function vehicleCRLVFileBlob(vehicleId) {
  return axios
    .get(
      `/vehicles/${vehicleId}/crlv`,
      { responseType: 'blob' }
    );
}

export function vehicleConsentFormFileBlob(vehicleId) {
  return axios
    .get(
      `/vehicles/${vehicleId}/consentForm`,
      { responseType: 'blob' }
    );
}
